import { useMutation } from '@tanstack/react-query'

import { updateCommentTemplate } from '@src/api'
import { useAxios } from '@src/hooks'

import { MutationMemoTemplateArgs } from './type'

export const useUpdateCommentTemplate = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: ({
      organizationId,
      commentTemplateId,
      params,
    }: MutationMemoTemplateArgs) =>
      updateCommentTemplate(
        axiosInstance,
        organizationId,
        commentTemplateId,
        params
      ),
  })
}
